import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeoCoordsService } from './geo-coords.service';

@NgModule({
  imports: [CommonModule],
  providers: [GeoCoordsService],
})
export class GeoCoordsDataAccessModule {}
